import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const StepTwoSpot = ({
  spotBgColor = '#FFF',
}: IconProps = {}): React.ReactElement => (
  <svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" fill={spotBgColor} r="16" />
    <path
      d="M17.8438 14.2656C17.8438 16.125 15.2812 18.4844 12.4531 20.8281V22H20.0312V20.5625H14.7031C17.2344 18.6562 19.6094 16.1875 19.6094 14.0156C19.6094 12.2344 18.3438 10.8906 16.125 10.8906C14.75 10.8906 13.5 11.4531 12.6875 12.1094V13.7188C13.5156 13 14.7031 12.4062 15.8594 12.4062C17.125 12.4062 17.8438 13.1094 17.8438 14.2656Z"
      fill="#515354"
    />
  </svg>
);
